import createVueApp from '@phoenix/createVueApp';
import WatchComparatorPanel from '@maison/components/watchComparator/WatchComparatorPanel.vue';

const el = document.getElementById('phoenix-watch-comparator-panel');
if (el) {
  const app = createVueApp({}, true);
  app.component('WatchComparatorPanel', WatchComparatorPanel);
  app.mount(el);
}
